export const featureFlags = {
    global: {
        isStorylyContentEnabled:
            process.env.REACT_APP_STORYLY_IS_ENABLED === "true",
    },
};
